<app-dialog-header [title]="'PAGE.MODULE_DETAILS.TAB.ATTENDANCE.TITLE'" [additionalText]="'-' + moduleName" (onClick)="dialogRef.close(false)"></app-dialog-header>

<div mat-dialog-content class="content p-24 pb-0" fxLayout="column" fxLayoutAlign="start">
    <mat-list fxLayout="row wrap" fxLayout.xs="column wrap" *ngIf="moduleEventAttendance.participantAttendancesSubject$ | async; let participantAttendances">
        <mat-list-item class="manage-attendances-list-container mb-12 mr-8 w-50" *ngFor="let participantAttendance of participantAttendances">
            <div class="w-100-p" fxLayout="row" fxLayoutAlign="space-between center">
                <div fxLayout="row" fxLayoutAlign="space-between center" class="manage-attendances-list-item w-100-p">
                    <div class="w-100-p" fxLayout="column" fxLayoutAlign="start">
                        <span class="title">{{ participantAttendance.event.name }}</span>
                        <div class="date mt-4">
                            <span>{{ participantAttendance.event.start | date: 'medium' }} - {{ participantAttendance.event.end | date: 'medium' }}</span>
                            <span *ngIf="participantAttendance.event.location"> {{ 'GENERAL.LABEL.IN' | translate }} {{ participantAttendance.event.location.name }} </span>
                        </div>
                        <div fxLayout="column" class="mt-20">
                            <div>
                                <span class="key">{{ 'PAGE.MODULE_DETAILS.TAB.ATTENDANCE.TITLE' | translate }}: </span>
                                <span class="value">
                                    {{
                                        (participantAttendance.status === AttendanceStatus.UNMARKED
                                            ? 'EVENT.ATTENDANCE.STATUS.UNMARKED'
                                            : (participantAttendance.status | getStatusByValue: attendanceStatuses:'translationLabel')
                                        ) | translate
                                    }}
                                </span>
                            </div>
                            <div *ngIf="participantAttendance.comment">
                                <span class="key">{{ 'FORM.EVENT.FIELD.DESCRIPTION' | translate }}: </span>
                                <span class="value">{{ participantAttendance.comment }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </mat-list-item>
    </mat-list>
</div>
<div class="pt-24 action-buttons" fxLayout="row" fxLayoutAlign="end center">
    <app-white-button [label]="'GENERAL.BUTTON.CLOSE'" (onClick)="dialogRef.close(false)"></app-white-button>
</div>
